import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeAuth } from './services/api';
import AuthWarningModal from './components/AuthWarningModal';
import VioExternalApiKeyGate from './components/VioExternalApiKeyGate';

// Root App component with auth modal
function RootApp() {
  const [showWarning, setShowWarning] = useState(false);
  const [authInitialized, setAuthInitialized] = useState(false);
  /** Any session with a refresh token should run the VIO key gate (sync can fail independently). */
  const [hasOpsSession, setHasOpsSession] = useState(false);

  useEffect(() => {
    initializeAuth().then((result) => {
      setAuthInitialized(true);
      setHasOpsSession(!!result.hasRefreshToken);
      // Show warning if no refresh token found
      if (!result.hasRefreshToken) {
        setShowWarning(true);
      }
    });
  }, []);

  const handleCloseWarning = () => {
    setShowWarning(false);
  };

  if (!authInitialized) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '1.2rem',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  if (hasOpsSession) {
    return (
      <VioExternalApiKeyGate>
        <App />
        <AuthWarningModal isOpen={showWarning} onClose={handleCloseWarning} />
      </VioExternalApiKeyGate>
    );
  }

  return (
    <>
      <App />
      <AuthWarningModal isOpen={showWarning} onClose={handleCloseWarning} />
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RootApp />
  </React.StrictMode>
);

reportWebVitals();

